import React, { useState, useEffect } from "react"
import { Grid, Box, Button, Tooltip, IconButton } from '@mui/material'
import { Stack, Paper, styled, Typography, Autocomplete, TextField, InputAdornment, LinearProgress, Container } from '@mui/material'
import makeStyles from "@mui/styles/makeStyles"
import RegisterItem from "../components/RegisterItem"
import { MoveToInbox, Search } from '@mui/icons-material'
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import { useSnackbar } from "../providers/SnackbarProvider";

const useStyles = makeStyles({
    pageRegister: {
        marginBottom: "35px"
    }
})

const Item = styled(Paper)(({ theme }) => ({
    backgroundColor: theme.palette.mode === 'dark' ? '#1A2027' : '#fff',
    ...theme.typography.body2,
    padding: theme.spacing(1.5),
    textAlign: 'center',
    color: theme.palette.text.secondary,
    width: '100%',
    border: '3px solid #E0E0E0',
    borderLeft: '3px solid #7F8C8D',
    borderRadius: '20px',
    boxShadow: '0 4px 12px rgba(0, 0, 0, 0.15)',
    transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
    '&:hover': {
        transform: 'translateY(-3px)',
        borderLeft: '3px solid #27AE60',
        boxShadow: '0 6px 16px rgba(0, 0, 0, 0.2)'
    }
}));

const ItemHeader = styled(Paper)(({ theme }) => ({
    backgroundColor: '#2C3E50',
    ...theme.typography.body2,
    padding: theme.spacing(1.5),
    textAlign: 'center',
    color: '#ECF0F1',
    width: '100%',
    minHeight: '48px',
    borderRadius: '20px 20px 0 0',
    borderBottom: '3px solid #27AE60',
    fontWeight: 600,
    background: 'linear-gradient(135deg, #2C3E50 0%, #34495E 100%)'
}));

export default function Registers(props) {
    const classes = useStyles()

    const [serialNumber, setSerial] = useState(props.serial)
    const [registers, setRegisters] = useState([])
    const [registerList, setRegisterList] = useState([])
    const [isLoading, setIsLoading] = useState(false)
    const [autocompleteList, setAutocompletelist] = useState([])
    const { openSnackbar } = useSnackbar();

    const [register, createDll] = useState([])

    const autocomplete = (event) => 
        {
        if (event.target.innerText === undefined || event.target.innerText === "") {
            setRegisterList(registers)
        } else {
            var autocomplete = registers.find(item => item.dS_NUM_SERIE === event.target.innerText.split(" - ")[1])
            setRegisterList(Array(autocomplete))
        }
    }
    const populateData = () => {
        setIsLoading(true);

        fetch(`${process.env.REACT_APP_URL}/register/all`, {
            method: 'POST',
            headers: {
                "content-type": "application/json",
                "Authorization": "Bearer " + props.token
            },
            body: JSON.stringify({ serialNumber })
        })
        .then(res => res.json())
        .then(data => {
            setRegisterList(data.sort((a, b) => parseInt(a.vL_MEM) - parseInt(b.vL_MEM)))
            setRegisters(data.sort((a, b) => parseInt(a.vL_MEM) - parseInt(b.vL_MEM)))
            setAutocompletelist(data.map(item => {
                return {
                    label: item.vL_MEM + " - " + item.dS_NUM_SERIE + " - " + item.dS_DESCRICAO + " - " + item.fK_GRUPO.slice(12) + " - " + item.dS_LOCALIZACAO
                }
            }
            ))
            setIsLoading(false);
        });
    }

    useEffect(() => {
        populateData();
    }, [])

    const header = {
        id: 1,
        vL_MEM: "Pos. Memória",
        dS_NUM_SERIE: "I.D.",
        dS_DESCRICAO: "Descrição",
        fK_GRUPO: "000000000000Grupo",
        dS_LOCALIZACAO: "Localização"
    }

    const syncRegistersWithCloud = async () => {
        setIsLoading(true);
        try {
            const companyId = props.companyId;
            if (!companyId) {
                openSnackbar("Empresa não disponível para sincronizar.", "error");
                setIsLoading(false);
                return;
            }

            const webromResponse = await fetch(
                `${process.env.REACT_APP_URL}/register/add-webrom?companyId=${companyId}`,
                {
                    method: "POST",
                    headers: { "content-type": "application/json" }
                }
            );
            const webromResult = await webromResponse.json();
            if (!webromResult.status) {
                openSnackbar("Falha ao sincronizar com Web.", "error");
            } else {
                openSnackbar("Sincronização com Web realizada com sucesso!", "success");
            }
        } catch (error) {
            console.error("Erro ao sincronizar com Web:", error);
            openSnackbar("Erro ao sincronizar com Web.", "error");
        } finally {
            setIsLoading(false);
        }
    };

    const createDllButton = () => {
        setIsLoading(true);

        fetch(`${process.env.REACT_APP_URL}/register/dll?serial=${serialNumber}`,
        {
            method: "GET",
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
                'Access-Control-Expose-Headers': '*',
                "Authorization": "Bearer " + props.token
            }
        })
        .then(response => response.blob())
        .then(blob => {
            const url = window.URL.createObjectURL(
                new Blob([blob]),
            );
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute(
                'download',
                'Config.dll',
            );

            // Append to html link element page
            document.body.appendChild(link);

            // Start download
            link.click();

            // Clean up and remove the link
            link.parentNode.removeChild(link);
        })
        .then(setIsLoading(false));
    }

    return (
        <main class="container" style={{ paddingTop: '1.5rem', paddingBottom: '2rem' }}>
            {isLoading && 
                <LinearProgress color="secondary" style={{position: "fixed", top: "0", left: "0", width: "100%", zIndex: "1201"}} /> 
            }

            <Box sx={{ 
                bgcolor: 'transparent',
                borderBottom: '1px solid rgba(224, 224, 224, 0.3)',
                borderRadius: '0',
                padding: '8px 0',
                marginBottom: '1rem',
                boxShadow: 'none',
                textAlign: 'center',
                cursor: 'default',
                pointerEvents: 'none',
                userSelect: 'none'
            }}>
                <Typography 
                    variant="h5" 
                    component="h3" 
                    sx={{ 
                        fontWeight: 400,
                        color: 'text.secondary',
                        letterSpacing: '0.5px',
                        textTransform: 'uppercase',
                        fontSize: '0.95rem'
                    }}
                >
                    Equipamentos Cadastrados
                </Typography>
            </Box>

            <Box sx={{ 
                display: 'flex', 
                justifyContent: 'space-between', 
                alignItems: 'center',
                mb: 3,
                flexWrap: 'wrap',
                gap: 2
            }}>
                {process.env.REACT_APP_MODE === 'desktop' && (
                    <Box sx={{ display: 'flex', gap: 1 }}>
                        <Tooltip title="Salvar .DLL">
                            <IconButton 
                                onClick={() => createDllButton()} 
                                disabled={isLoading}
                                sx={{
                                    bgcolor: 'rgba(52, 152, 219, 0.2)',
                                    border: '2px solid #3498DB',
                                    '&:hover': { bgcolor: 'rgba(52, 152, 219, 0.4)' }
                                }}
                            >
                                <MoveToInbox />
                            </IconButton>
                        </Tooltip>
                        <Tooltip title="Sincronizar com Web">
                            <IconButton 
                                onClick={() => { syncRegistersWithCloud() }} 
                                disabled={isLoading}
                                sx={{
                                    bgcolor: 'rgba(39, 174, 96, 0.2)',
                                    border: '2px solid #27AE60',
                                    '&:hover': { bgcolor: 'rgba(39, 174, 96, 0.4)' }
                                }}
                            >
                                <CloudUploadIcon />
                            </IconButton>
                        </Tooltip>
                    </Box>
                )}

                <Box sx={{ 
                    bgcolor: 'rgba(255, 255, 255, 0.05)',
                    border: '3px solid #E0E0E0',
                    borderRadius: '20px',
                    padding: '12px 24px',
                    boxShadow: '0 4px 12px rgba(0, 0, 0, 0.15)',
                    marginLeft: 'auto'
                }}>
                    <Typography variant="h6" color="textPrimary">
                        Equipamentos Encontrados: <strong>{registers.length}</strong>
                    </Typography>
                </Box>
            </Box>


            <Grid container spacing={2} textAlign='center' sx={{ marginTop: "5px", marginBottom: "2rem" }} >
                <Grid item xs={12} md={12} lg={12} width={"100%"}  >
                    <Autocomplete
                        disablePortal
                        id="combo-box-demo"
                        options={autocompleteList}
                        onChange={(event) => autocomplete(event)}
                        sx={{
                            '& .MuiOutlinedInput-root': {
                                borderRadius: '20px',
                                backgroundColor: 'rgba(255, 255, 255, 0.05)',
                                border: '3px solid #E0E0E0',
                                boxShadow: '0 4px 12px rgba(0, 0, 0, 0.15)',
                                transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
                                '&:hover': {
                                    transform: 'translateY(-2px)',
                                    boxShadow: '0 6px 16px rgba(0, 0, 0, 0.2)',
                                    borderColor: '#27AE60'
                                },
                                '&.Mui-focused': {
                                    borderColor: '#27AE60',
                                    boxShadow: '0 6px 16px rgba(39, 174, 96, 0.3)'
                                },
                                '& fieldset': {
                                    border: 'none'
                                }
                            }
                        }}
                        renderInput={(params) =>
                            <TextField
                                {...params}
                                placeholder="Pesquisar"
                                InputProps={{
                                    ...params.InputProps,
                                    startAdornment: (<InputAdornment><Search color="secondary" /></InputAdornment>)
                                }}
                            />
                        }
                    />
                </Grid>
            </Grid>

            <Stack sx={{ maxWidth: "100%", marginBottom: "35px" }} alignItems="center" spacing={2}>
                <ItemHeader item key={header.id} xs={12} md={6} lg={4}>
                    <RegisterItem register={header} />
                </ItemHeader>
                {registerList.map(register => (
                    <Item item key={register.id} xs={12} md={6} lg={4}>
                        <RegisterItem register={register} />
                    </Item>
                ))}
            </Stack>
        </main>
    )
}